import Checkbox from 'components/subscribe/property/Checkbox';

import './Campaign.css';

const Campaign = ({
  campaignURN,
  campaignName,
  isSelected,
  handleSelection,
}: {
  campaignURN: string;
  campaignName: string;
  isSelected: boolean;
  handleSelection: (id: string) => void;
}) => {
  const handleChange = (id: string) => {
    handleSelection(id);
  };

  return (
    <Checkbox
      className={`campaign__container__${isSelected ? 'enabled' : 'disabled'}`}
      handleChange={handleChange}
      id={campaignURN}
      isSelected={isSelected}
      labelName={campaignName}
    />
  );
};

export default Campaign;
